// src/components/LpShortcuts.js
import React, { useState, useEffect, useRef } from 'react';

// Import your icons
import yahoo from '../assets/images/logos/yahoomail.svg';
import youtube from '../assets/images/logos/new-youtube-logo.svg';
import gmail from '../assets/images/logos/gmail.svg';
import aol from '../assets/images/logos/aol.svg';
import facebook from '../assets/images/logos/facebook.svg';
import xLogo from '../assets/images/logos/x-2.svg'; // renamed variable for clarity
import instagram from '../assets/images/logos/instagram.svg';
import zoom from '../assets/images/logos/zoom.svg';
import tiktok from '../assets/images/logos/tiktok.svg';
import whatsapp from '../assets/images/logos/whatsapp.svg';
import linkedin from '../assets/images/logos/linkedin.svg';
import snapchat from '../assets/images/logos/snapchat.svg';
import proton from '../assets/images/logos/proton.svg';
import pinterest from '../assets/images/logos/pinterest.svg';
import reddit from '../assets/images/logos/reddit.svg';
import wechat from '../assets/images/logos/wechat.svg';
import telegram from '../assets/images/logos/telegram.svg';
import skype from '../assets/images/logos/skype.svg';
import slack from '../assets/images/logos/slack.svg';
import vimeo from '../assets/images/logos/vimeo.svg';
import tumblr from '../assets/images/logos/tumblr.svg';
import discord from '../assets/images/logos/discord.svg';
import signal from '../assets/images/logos/signal.svg';
import viber from '../assets/images/logos/viber.svg';

const allIcons = [
  { name: 'Yahoo Mail', file: yahoo, url: 'https://mail.yahoo.com' },
  { name: 'YouTube', file: youtube, url: 'https://youtube.com' },
  { name: 'Gmail', file: gmail, url: 'https://mail.google.com' },
  { name: 'AOL', file: aol, url: 'https://mail.aol.com' },
  { name: 'Facebook', file: facebook, url: 'https://facebook.com' },
  { name: 'X (Twitter)', file: xLogo, url: 'https://twitter.com' },
  { name: 'Instagram', file: instagram, url: 'https://instagram.com' },
  { name: 'Zoom', file: zoom, url: 'https://zoom.us' },
  { name: 'TikTok', file: tiktok, url: 'https://tiktok.com' },
  { name: 'WhatsApp', file: whatsapp, url: 'https://whatsapp.com' },
  { name: 'LinkedIn', file: linkedin, url: 'https://linkedin.com' },
  { name: 'Snapchat', file: snapchat, url: 'https://snapchat.com' },
  { name: 'ProtonMail', file: proton, url: 'https://proton.me' },
  { name: 'Pinterest', file: pinterest, url: 'https://pinterest.com' },
  { name: 'Reddit', file: reddit, url: 'https://reddit.com' },
  { name: 'WeChat', file: wechat, url: 'https://wechat.com' },
  { name: 'Telegram', file: telegram, url: 'https://telegram.org' },
  { name: 'Skype', file: skype, url: 'https://skype.com' },
  { name: 'Slack', file: slack, url: 'https://slack.com' },
  { name: 'Vimeo', file: vimeo, url: 'https://vimeo.com' },
  { name: 'Tumblr', file: tumblr, url: 'https://tumblr.com' },
  { name: 'Discord', file: discord, url: 'https://discord.com' },
  { name: 'Signal', file: signal, url: 'https://signal.org' },
  { name: 'Viber', file: viber, url: 'https://viber.com' }
];

const LpShortcuts = ({ buyFreeTrial }) => {
  const [selectedIcons, setSelectedIcons] = useState(() => {
    const saved = localStorage.getItem('selectedIcons');
    return saved ? JSON.parse(saved) : [];
  });
  const [showAll, setShowAll] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const containerRef = useRef(null);

  // Save selected icons to localStorage whenever updated
  useEffect(() => {
    localStorage.setItem('selectedIcons', JSON.stringify(selectedIcons));
  }, [selectedIcons]);

  // Check if the "Save Favorites" button should be sticky
  useEffect(() => {
    const checkScroll = () => {
      if (containerRef.current) {
        const containerBottom = containerRef.current.getBoundingClientRect().bottom;
        const windowHeight = window.innerHeight;
        // If container bottom is well below the viewport, show sticky
        setIsSticky(containerBottom > windowHeight + 100);
      }
    };

    checkScroll();
    window.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    return () => {
      window.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, [showAll]);

  // Toggle selection of an icon
  const toggleIcon = (name) => {
    setSelectedIcons(prev =>
      prev.includes(name)
        ? prev.filter(n => n !== name)
        : [...prev, name]
    );
  };

  // Display fewer icons by default; show all if user requests
  const displayedIcons = showAll ? allIcons : allIcons.slice(0, 10);

  return (
    <div className="shortcut-links-container" ref={containerRef}>
      <div className="shortcut-links">
        {displayedIcons.map((icon) => (
          <div
            key={icon.name}
            className={`shortcut-item ${selectedIcons.includes(icon.name) ? 'selected' : ''}`}
            onClick={() => toggleIcon(icon.name)}
          >
            <div className="icon-wrapper">
              <img src={icon.file} alt={icon.name} className="icon" />
            </div>
            <div className="corner-tab" />
            <div className="checkmark">L</div>
          </div>
        ))}
      </div>

      {allIcons.length > 10 && (
        <div className="show-more-container">
          <button onClick={() => setShowAll(!showAll)}>
            {showAll ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )}

      {selectedIcons.length > 0 && (
        <>
          {/* Default button container (inline) */}
          <div className={`default-button-container ${isSticky ? 'hidden' : ''}`}>
            <button onClick={buyFreeTrial} className="save-favorites-button pulse-glow">
              Save Favorites
            </button>
          </div>
          
          {/* Sticky button container (fixed at bottom) */}
          <div className={`sticky-button-container ${isSticky ? 'visible' : ''}`}>
            <button onClick={buyFreeTrial} className="save-favorites-button pulse-glow">
              Save Favorites
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default LpShortcuts;
